export const SLIDING_BANNER_CONFIG = {
  basePath: "/banners",
  documentTitleKey: "Banners ",
  breadcrumbKey: "Banners",
  listTitleKey: "Banners List",
  permissionCategoryId: 2,
  permissions: {
    view: "inAppContent_1",
    add: "inAppContent_2",
    update: "inAppContent_3",
    delete: "inAppContent_4",
  },
  api: {
    list: "admin/banner/all",
    add: "admin/banner/add",
    details: "admin/banner/details",
    update: "admin/banner/details/update",
    delete: "admin/banner/delete",
    updateStatus: "admin/banner/details/update-status",
    slideDetails: "admin/slide/details",
    slideAdd: "admin/slide/add",
    slideUpdate: "admin/slide/details/update",
    slideUpdateStatus: "admin/slide/details/update-status",
    slideDelete: "admin/slide/delete",
  },
  reduxNamespace: "Banners",
}

export const OFFER_BANNER_CONFIG = {
  basePath: "/offer-banners",
  documentTitleKey: "Offer Banners",
  breadcrumbKey: "Offer Banners",
  listTitleKey: "Offer Banners List",
  permissionCategoryId: 49,
  permissions: {
    view: "offerBanner_1",
    add: "offerBanner_2",
    update: "offerBanner_3",
    delete: "offerBanner_4",
  },
  api: {
    list: "admin/offer-banner/all",
    add: "admin/offer-banner/add",
    details: "admin/offer-banner/details",
    update: "admin/offer-banner/details/update",
    delete: "admin/offer-banner/delete",
    updateStatus: "admin/offer-banner/details/update-status",
    slideDetails: "admin/offer-slide/details",
    slideAdd: "admin/offer-slide/add",
    slideUpdate: "admin/offer-slide/details/update",
    slideUpdateStatus: "admin/offer-slide/details/update-status",
    slideDelete: "admin/offer-slide/delete",
  },
  reduxNamespace: "OfferBanners",
}
